module.exports = __webpack_public_path__ + "img/52.7.Chla.6ddafb77.png";